import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * Identical flow to the editor's AuthCallback — see editor/src/pages/
 * AuthCallback.tsx for the rationale on accepting `INITIAL_SESSION`
 * and not double-exchanging the PKCE code.
 */
export function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const url = new URL(window.location.href);
    const errParam = url.searchParams.get('error_description') ?? url.searchParams.get('error');
    if (errParam) {
      navigate(`/sign-in?error=${encodeURIComponent(errParam)}`, { replace: true });
      return;
    }

    let resolved = false;

    function done(hasSession: boolean) {
      if (resolved) return;
      resolved = true;
      navigate(hasSession ? '/' : '/sign-in?error=no_session', { replace: true });
    }

    supabase.auth.getSession().then(({ data }) => {
      if (data.session) done(true);
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) done(true);
    });

    const timeout = window.setTimeout(() => {
      if (!resolved) {
        setError('Sign-in timed out. The link may have expired or already been used.');
      }
    }, 10_000);

    return () => {
      sub.subscription.unsubscribe();
      window.clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div className="center-page">
      {error ? (
        <div className="card" style={{ maxWidth: 420 }}>
          <div className="alert alert-error">{error}</div>
          <button
            type="button"
            className="btn btn-secondary"
            style={{ marginTop: 12 }}
            onClick={() => navigate('/sign-in', { replace: true })}
          >
            Back to sign in
          </button>
        </div>
      ) : (
        <div className="spinner" />
      )}
    </div>
  );
}
